import authServices from "../services/AuthServices";
import apiClient from "./apiClient";

export const loginSession = async () => {
    const token = authServices.getToken();

    try {
        const response = await apiClient.post(`/login/loginSession`,
            {}, // Pass any body data if required
            {
                headers: {
                    Authorization: token
                },
            }
        );

        // Return the status if API call is successful
        return { response: response.data.Status };
    } catch (error) {
        console.error("Error during API call:", error);
        return { response: error.response.data.Status };
    }
};